import { readMarketingAttribution } from './MarketingAttribution';
import { hasMarketingConsent } from './Consent';

// Without Accept on the privacy banner, events go nowhere.
const getDefaultDataLayer = () => {
  if (typeof window === 'undefined' || !hasMarketingConsent()) {
    return null;
  }

  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

const getDefaultGtag = () => {
  if (
    typeof window === 'undefined' ||
    typeof window.gtag !== 'function' ||
    !hasMarketingConsent()
  ) {
    return null;
  }
  return window.gtag;
};

export const pushMarketingEvent = ({
  storage,
  dataLayer = getDefaultDataLayer(),
  gtag = getDefaultGtag(),
  product = 'nucleus_one',
  ...eventProperties
} = {}) => {
  if (!dataLayer || !eventProperties.event) {
    return null;
  }

  const attribution = readMarketingAttribution(storage);
  const payload = {
    ...eventProperties,
    product,
    has_marketing_attribution: Boolean(attribution),
  };

  if (attribution) {
    payload.marketing_landing_url = attribution.landingUrl;
    payload.marketing_referrer = attribution.referrer;
    payload.marketing_params = attribution.params;

    if (attribution.params?.am_session_id) {
      payload.am_session_id = attribution.params.am_session_id;
    }
    if (attribution.params?.am_visitor_id) {
      payload.am_visitor_id = attribution.params.am_visitor_id;
    }
    if (attribution.params?.am_handoff) {
      payload.am_handoff = attribution.params.am_handoff;
    }
  }

  if (gtag) {
    const { event, ...analyticsProperties } = payload;
    // The production app loads gtag.js directly rather than GTM. A plain
    // dataLayer object is not a gtag command, so send the event through the
    // installed transport when it is available. Development and staging keep
    // queuing the object without loading production analytics.
    gtag('event', event, analyticsProperties);
  } else {
    dataLayer.push(payload);
  }
  return payload;
};
